import { render, staticRenderFns } from "./application-header.vue?vue&type=template&id=b5b7d3a6&scoped=true"
import script from "./application-header.vue?vue&type=script&lang=js"
export * from "./application-header.vue?vue&type=script&lang=js"
import style0 from "./application-header.vue?vue&type=style&index=0&id=b5b7d3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b7d3a6",
  null
  
)

export default component.exports